import { CountryCodes, type Market } from '@bridebook/toolbox/src/gazetteer';

interface IValidForMarketProps {
  supplierCountry?: CountryCodes;
  market: Market;
  isLoggedIn: boolean;
}

/**
 * Validate supplier or search country and market so only relevant country specific suppliers are displayed.
 * @param supplierCountry - supplier or search address country code
 * @param market - actual market
 * @param isLoggedIn - if true, then users can see all the suppliers from every country
 */
export const isValidForMarket = ({
  supplierCountry,
  market,
  isLoggedIn,
}: IValidForMarketProps): boolean => {
  /**
   * Logged in users can see all the suppliers from every country.
   */
  if (isLoggedIn) {
    return true;
  }

  if (!supplierCountry) {
    return true;
  }

  /**
   * Logged out users can only see suppliers from the market country.
   */
  return market.country === supplierCountry;
};
